module.exports = __webpack_public_path__ + "media/assets/images/flags/lr-a7840fcd0397d115d3138cc7aa9668d5.svg";